module.exports = require("./os");